import React, { useState, useEffect } from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import styled from 'styled-components';
import { map } from 'styled-components-breakpoint';
import { mb, mt, pt, pb, px, my } from 'styled-components-spacing';
import { osName } from 'react-device-detect';

import { colors, Text, Heading } from 'themes/components';
import HighlightText from 'utils/HighlightText';
import Button, { ButtonStyles } from 'components/Button';
import WindowsIcon from '../../assets/icons/Windows';
import MacOSIcon from '../../assets/icons/MacOS';

const Container = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  display: grid;
  align-items: center;
  ${pt({ mobile: 2, tablet: 8 })};
  ${pb({ mobile: 2 })};
  ${my({ mobile: 2, tablet: 8 })};
  ${px(2)};
  ${map(
    {
      mobile: '1fr',
      tablet: '1fr 1fr',
      desktop: '1fr 0.7fr'
    },
    (cols) => `grid-template-columns: ${cols};`
  )};
  ${map(
    {
      mobile: '0',
      tablet: '40px',
      desktop: '80px'
    },
    (gap) => `grid-column-gap: ${gap};`
  )}
  gap: 24px;
  ${map(
    {
      mobile: '"content" "cta" "image"',
      tablet: '"content image" "cta image"'
    },
    (areas) => `grid-template-areas: ${areas};`
  )}
`;

const Content = styled.div`
  grid-area: content;
  & > h1 {
    ${mb(0)}
  }
`;
const Image = styled.div`
  grid-area: image;
`;

const CtaWrapper = styled.div`
  grid-area: cta;
  /* ${mt(2)} */
`;

const IconButton = styled(Button)`
  display: inline-flex;
  align-items: center;
  & > svg {
    margin-right: 8px;
  }
`;

const Hero = () => {
  const [os, setOs] = useState('');

  useEffect(() => {
    setOs(osName);
  }, []);

  const MacView = ({ children }) => {
    if (os === 'Mac OS') {
      return children;
    }
    return null;
  };

  const WinView = ({ children }) => {
    if (os === 'Windows') {
      return children;
    }
    return null;
  };

  const SignUpButton = ({ children }) => {
    if (os === 'Mac OS' || os === 'Windows') {
      return null;
    }
    return children;
  };

  return (
    <Container>
      <Content>
        <Text
          style={{ fontWeight: '600', marginBottom: '4px' }}
          variant="subhead"
        >
          <HighlightText stopOne={colors.purple40} stopTwo={colors.blue30}>
            Engineers &rarr;
          </HighlightText>
        </Text>
        <Heading variant="hero" style={{ color: `${colors.grey5}` }}>
          Build better art pipelines.
        </Heading>
        <Text variant="subhead" hero style={{ color: `${colors.grey30}` }}>
          Revolutionize the way your game dev team manages and interacts with
          digital assets.
        </Text>
        <Text
          variant="subhead"
          hero
          style={{ color: `${colors.grey30}`, marginTop: '12px' }}
        >
          It’s not just about storage—it’s about making your entire pipeline
          more efficient and secure.
        </Text>
      </Content>
      {/* <CtaWrapper>
        {os === 'Windows' && (
          <WinView>
            <IconButton
              secondary
              download
              href="https://mudstack-desktop.s3.amazonaws.com/mudstack_windows_latest.exe"
            >
              <WindowsIcon fillColor={colors.grey5} />
              Download for Windows
            </IconButton>
          </WinView>
        )}
        {os === 'Mac OS' && (
          <MacView>
            <IconButton
              secondary
              download
              href="https://mudstack-desktop.s3.amazonaws.com/mudstack_mac_latest.dmg"
            >
              <MacOSIcon fillColor={colors.grey5} />
              Download for Mac
            </IconButton>
          </MacView>
        )}
        {os !== 'Windows' && os !== 'Mac OS' && (
          <SignUpButton>
            <Button
              as="a"
              href="https://app.mudstack.com/signup"
              rel="nofollow"
            >
              Sign up free
            </Button>
          </SignUpButton>
        )}
      </CtaWrapper> */}
      <Image>
        <StaticImage
          src="./images/hero.png"
          alt="hero image todo"
          loading="eager"
        />
      </Image>
    </Container>
  );
};

export default Hero;
